<template>
  <div style="height: 100%; width: 100%">
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 95%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="markerLatLng" :icon="icon">
        <l-popup>
          <div @click="innerClick">موقعیت</div>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { latLng, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LLayerGroup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "address-map",

  props: ["lat", "lng"],

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    let ll = latLng(this.$props.lat, this.$props.lng);
    return {
      zoom: 15,
      center: ll,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markerLatLng: ll,
      currentZoom: 15,
      currentCenter: ll,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      icon: icon({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [25, 41],
        iconAnchor: [16, 37],
      }),
    };
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },

    innerClick() {
      alert("Click!");
    },
  },

  watch: {
    lat: function (newVal, oldVal) {
      this.markerLatLng = latLng(newVal, this.markerLatLng.lng);
      this.center = this.markerLatLng;
    },
    lng: function (newVal, oldVal) {
      // watch it
      this.markerLatLng = latLng(this.markerLatLng.lat, newVal);
      this.center = this.markerLatLng;
    },
  },
};
</script>
